var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"artist-avatar",attrs:{"href":_vm.artist.uri}},[_c('img',{staticClass:"rounded-circle",attrs:{"src":_vm.artist.imageUris.avatarSm.url,"alt":_vm.artist.name,"width":"41","height":"41"}}),_vm._v(" "),(_vm.withName)?_c('span',{staticClass:"name d-inline-block ml-2"},[_vm._v(_vm._s(_vm.artist.name))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }